import { DownloadCloud, Eye, File, Trash } from "lucide-react"; // Íconos modernos
import { useDispatch } from 'react-redux';
import FormPDF from '../../containers/panel/forms/FormPDF';
import { clearFormThunk } from "../../store/slices/public/procesoMatriculacion.slice";

const CardForms = ({ title, datos, items }) => {

    const dispatch = useDispatch();

    const handleCleartForm = (data) => {
        dispatch(clearFormThunk(data))
    }

    const handleGenerateReport = (item) => {
        FormPDF(datos, item);
    };

    return (
        <div className="bg-white rounded-2xl shadow-lg p-4 border border-gray-200">
            <div className='flex items-center gap-2 mb-3'>
                <File className="w-4 h-4" />
                <h2 className="text-lg font-semibold text-gray-700 uppercase text-left">{title}</h2>
            </div>
            <div className="space-y-3">
                {items.length === 0 ? (
                    <p className="text-sm text-gray-400">No hay elementos</p>
                ) : (
                    items?.map((item, idx) => (
                        <div key={idx} className="flex gap-3 justify-between items-center bg-gray-100 rounded-xl px-3 py-2 hover:bg-gray-200 transition">
                            <div className='flex flex-col justify-start text-left'>
                                <span className="text-sm font-medium text-gray-600 uppercase">
                                    {item.formulario.titulo}
                                </span>
                                <span
                                    className={`text-[12px] font-semibold flex items-center gap-1 mt-1 ${item.isSubmited ? "text-green-600" : "text-red-500"
                                        }`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-4 w-4"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        {item.isSubmited ? (
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        ) : (
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        )}
                                    </svg>
                                    {item.isSubmited ? "Formulario completado" : "Falta completar formulario"}
                                </span>
                            </div>
                            <div className="flex gap-2">
                                <button
                                    disabled={!item.isSubmited}
                                    onClick={() => handleGenerateReport(item)}
                                    className={`flex items-center gap-2 bg-gradient-to-r ${!item.isSubmited ? 'bg-slate-300' : ' from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 '} text-white px-4 py-2 rounded-xl shadow-md transition-all duration-300 ease-in-out`}
                                >
                                    <DownloadCloud className="w-4 h-4" />
                                </button>
                                <button
                                    disabled={!item.isSubmited}
                                    onClick={() => handleCleartForm(item)}
                                    className={`flex items-center gap-2 bg-gradient-to-r ${!item.isSubmited ? 'bg-slate-300' : ' from-rose-400 to-red-500 hover:from-rose-500 hover:to-red-600 '} text-white px-4 py-2 rounded-xl shadow-md transition-all duration-300 ease-in-out`}
                                >
                                    <Trash className="w-4 h-4" />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default CardForms;